import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import { Fade } from '@material-ui/core';
import Message from '../Message';
import moment from 'moment';
import DateDivider from '../DateDivider';
import LoaderMessages from './LoaderMessages';
import Attachment from './Attachment';
import classnames from 'classnames';
import './MessagesContainer.css';

class MessagesContainer extends PureComponent {
  constructor (props) {
    super(props);

    this.date = new Date();

    this.state = {
      atBottomOfMessageList: true,
      showNewMessageAlert: false
    };
  }

  /**
   * check if the list is currently at the bottom
   */
  get scrolledToBottom () {
    if (this.scrollerRef.current) {
      return this.scrollerRef.current.scrollTop === (this.scrollerRef.current.scrollHeight - this.scrollerRef.current.offsetHeight);
    }

    return true;
  }

  handleScroll = event => {
    if (
      this.props.scrollerRef.current &&
      this.props.scrollerRef.current.scrollTop < 200 &&
      this.props.hasMoreMessages &&
      !this.props.loadingMessages
    ) {
      if (this.props.messages.length) {
        const cursor = this.props.messages[this.props.messages.length - 1];
        this.props.fetchMoreMessages(cursor.createdAt);
      }
    }
  }

  formatTime = date => moment(date).format('h:mm A');

  isSameDate = (d1, d2) => moment(d1).isSame(moment(d2), 'date');

  render () {
    const showMessageSkeletons = this.props.loadingMessages && (!this.props.messages || this.props.messages.length === 0);

    if (showMessageSkeletons) {
      return <LoaderMessages />;
    }

    return (
      <Fade in>
        <div
          onDrop={this.props.onDrop}
          onDragLeave={this.props.onDragLeave}
          onDragOver={this.props.onDragOver}
          id={this.props.id}
          className='kt-channel-messages-container'
          onScroll={this.handleScroll}
          ref={this.props.scrollerRef}
        >
          { this.props.messages.length === 0
            ? <div style={{ padding: '0 20px' }}>
              <Typography>No messages have been sent</Typography>
            </div>
            : this.props.messages.map((message, index) => {
              const _date = this.date;
              const { id, message: messageContent, createdAt, senderId, user, attachment } = message;
              this.date = createdAt;
              const sentByCurrentUser = senderId === this.props.currentUserId;

              const messageTextClasses = classnames({
                'message-text': true,
                'message-text-me': sentByCurrentUser
              });

              return (
                <Fragment key={`channel-message-${id}`}>
                  { !this.isSameDate(_date, createdAt) && index !== 0 && <DateDivider date={_date} /> }
                  <Message
                    avatar={user ? user.avatar : ''}
                    sender={user ? user.name : ''}
                    sentAt={this.formatTime(createdAt)}
                    sentByCurrentUser={sentByCurrentUser}
                    attachment={attachment && <Attachment attachment={attachment} onClick={this.props.onAttachmentClick} />}
                  >
                    { messageContent && <span className={messageTextClasses}>{messageContent}</span> }
                  </Message>
                  { index === this.props.messages.length - 1 && <DateDivider date={createdAt} /> }
                </Fragment>
              );
            })}
        </div>
      </Fade>
    );
  }
}

MessagesContainer.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object),
  loadingMessages: PropTypes.bool,
  fetchMoreMessages: PropTypes.func,
  hasMoreMessages: PropTypes.bool,
  onAttachmentClick: PropTypes.func,
  scrollerRef: PropTypes.object // ref
};

export default MessagesContainer;
